import moment from "moment-timezone";
import { pluralize } from "humanize-plus";
import { NEW_REPORT } from "routes.js";

const template = `
	<a class="btn btn-link btn-sm"
		ng-if="$ctrl.showLink()"
		ng-click="$ctrl.goToReportDetails()"
		style="text-align: left"
		ng-bind-html="$ctrl.message">
	</a>
	<span ng-if="!$ctrl.showLink()" class="non-link-btn-link">{{$ctrl.message}}</span>
`;

// compliance-period-message
function controller($state, appState, $sce) {
	const ctrl = this;
	ctrl.permissions = appState.permissions;

	ctrl.$onChanges = onChanges;

	ctrl.getComplianceMessage = getComplianceMessage;
	ctrl.goToReportDetails = goToReportDetails;
	ctrl.showLink = showLink;

	function onChanges() {
		ctrl.message = getComplianceMessage();
	}

	function showLink() {
		return ctrl.status.Pending > 0 || ctrl.status.Submitted > 0 || (!ctrl.status.Negative && ctrl.status.hasBegun);
	}

	function getComplianceMessage() {
		const {
			Pending, Submitted, Negative 
		} = ctrl.status;

		if(Pending === 0 && Submitted === 0 && !Negative && ctrl.permissions.Reporting.Actions.CanCreate === true) {
			if(ctrl.status.hasBegun) {
				const label = `<i>Create first ${appState.forms.selected.nomenclature.PositiveReport}</i>`;
				return $sce.trustAsHtml(label);
			}
			return "--";
		}

		const messages = [];

		if(Pending > 0) {
			const label = pluralize(Pending, `${appState.forms.selected.nomenclature.PositiveReport}`);

			messages.push(`${Pending} Pending ${label}`);
		}

		if(Submitted > 0) {
			const label = pluralize(Submitted, `${appState.forms.selected.nomenclature.PositiveReport}`);

			messages.push(`${Submitted} Completed ${label}`);
		}

		if(Negative) {
			const label = `${appState.forms.selected.nomenclature.NegativeReport} Filed`;

			messages.push(label);
		}

		return $sce.trustAsHtml(messages.join("<br/>"));
	}

	function goToReportDetails() {
		if(ctrl.status.Pending > 0 || ctrl.status.Submitted > 0) {
			ctrl.timeZoneCode = ctrl.timeZoneCode || appState.forms.selected.TimeZone.Code;

			const range = {
				begin: moment.tz(ctrl.status.Period.BeginInclusive, ctrl.timeZoneCode).format(),
				end: moment
					.tz(ctrl.status.Period.EndExclusive, ctrl.timeZoneCode)
					.subtract(1, "seconds")
					.format()
			};

			$state.transitionTo("authenticated.report-list", { start: range.begin, end: range.end, entityIds: [ctrl.entityId] });
		} else {
			$state.transitionTo(NEW_REPORT);
		}
	}
}

export default angular.module("vesl.components.compliance-period-message", []).component("compliancePeriodMessage", {
	template,
	controller,
	bindings: {
		status: "<",
		timeZoneCode: "<",
		entityId: "<"
	}
}).name;
